import React, { useState, useEffect } from 'react';
import styles from './ProjectsModal.module.scss';

const projectsData = [
  { 
    name: "Launch 1: UP ONLY", 
    status: "Active", 
    launched: "2025-09-15",
    description: "Revolutionary satellite deployment system with advanced orbital mechanics",
    category: "GameFi Race Concept",
    featured: true
  },
  { 
    name: "Launch 2: Deep Space Probe", 
    status: "Development", 
    launched: "2025-08-01",
    description: "Long-range exploration probe for outer system reconnaissance",
    category: "Exploration"
  },
  { 
    name: "Launch 3: Communication Array", 
    status: "Planning", 
    launched: "2025-10-04",
    description: "Next-generation quantum communication satellite network",
    category: "Communications"
  },
  { 
    name: "Launch 4: [CLASSIFIED]", 
    status: "Planning", 
    launched: "2025-11-15",
    description: "Classified mission parameters",
    category: "Unknown"
  },
  { 
    name: "Launch 5: [CLASSIFIED]", 
    status: "Planning", 
    launched: "2025-12-01",
    description: "Classified mission parameters",
    category: "Unknown"
  },
  { 
    name: "Launch 6: [CLASSIFIED]", 
    status: "Planning", 
    launched: "2025-12-20",
    description: "Classified mission parameters",
    category: "Unknown"
  },
  { 
    name: "Launch 7: [CLASSIFIED]", 
    status: "Planning", 
    launched: "2026-01-10",
    description: "Classified mission parameters",
    category: "Unknown"
  },
  { 
    name: "Launch 8: [CLASSIFIED]", 
    status: "Planning", 
    launched: "2026-02-05",
    description: "Classified mission parameters",
    category: "Unknown"
  },
  { 
    name: "Launch 9: [CLASSIFIED]", 
    status: "Planning", 
    launched: "2026-03-15",
    description: "Classified mission parameters",
    category: "Unknown"
  },
  { 
    name: "Launch 10: [CLASSIFIED]", 
    status: "Planning", 
    launched: "2026-04-01",
    description: "Classified mission parameters",
    category: "Unknown"
  }
];

function ProjectsModal({ open, onClose, onViewProbeResults }) {
  const [garbledText, setGarbledText] = useState({});

  // Generate garbled text
  const generateGarbledText = (length) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=[]{}|;:,.<>?';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  // Update garbled text constantly for all classified launches
  useEffect(() => {
    const interval = setInterval(() => {
      const newGarbledText = {};
      
      // Generate garbled text for launches 2-10 (indices 1-9)
      for (let i = 1; i < projectsData.length; i++) {
        newGarbledText[`launch${i + 1}Name`] = generateGarbledText(20 + Math.floor(Math.random() * 15));
        newGarbledText[`launch${i + 1}Category`] = generateGarbledText(8 + Math.floor(Math.random() * 8));
      }
      
      setGarbledText(newGarbledText);
    }, 150); // Update every 150ms for fast changing effect

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={
      styles.projectsModal + ' ' + (open ? styles.open : '')
    }>
      {/* Modal Header */}
      <div className={styles.header}>
        <h2>Mission Control Dashboard</h2>
        <button className={styles.closeButton} onClick={onClose}>×</button>
      </div>
      
      {/* Featured Project Section */}
      <div className={styles.featuredSection}>
        <h3>Latest Probe Data</h3>
        {projectsData.filter(proj => proj.featured).map((proj, index) => (
          <div key={index} className={styles.featuredProject}>
            <div className={styles.projectHeader}>
              <span className={styles.projectName}>{proj.name}</span>
              <span className={`${styles.projectStatus} ${styles[proj.status.toLowerCase()]}`}>
                {proj.status}
              </span>
            </div>
            <div className={styles.projectCategory}>{proj.category}</div>
            <div className={styles.projectDate}>Launched: {proj.launched}</div>
            
            {/* Bottom section with social links and probe results button */}
            <div className={styles.featuredBottom}>
              {/* Social links for featured project */}
              <div className={styles.featuredSocialLinks}>
                <a href="https://x.com/uponlygame" target="_blank" rel="noopener noreferrer" className={styles.featuredSocialLink}>
                  <svg viewBox="0 0 24 24" className={styles.featuredSocialIcon}>
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
                
                <a href="https://uponlygame.com" target="_blank" rel="noopener noreferrer" className={styles.featuredSocialLink}>
                  <svg viewBox="0 0 24 24" className={styles.featuredSocialIcon}>
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                  </svg>
                </a>
                
                <a href="https://t.me/uponlygame" target="_blank" rel="noopener noreferrer" className={styles.featuredSocialLink}>
                  <svg viewBox="0 0 24 24" className={styles.featuredSocialIcon}>
                    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                  </svg>
                </a>
              </div>
              
              {/* View Probe Results Button */}
              <button 
                className={styles.probeResultsButton}
                onClick={() => {
                  // Generate sample probe data for Launch 1
                  const sampleProbeData = {
                    target: 'Moon 1 (Launch 1: UP ONLY)',
                    status: 'Analysis Complete',
                    distance: `${Math.floor(Math.random() * 2000 + 500)} km`,
                    signal: 'Strong',
                    analysis: 'Massive retardium deposits detected - perfect for diamond hands mining operations'
                  };
                  onViewProbeResults && onViewProbeResults(sampleProbeData);
                }}
              >
                View Probe Results
              </button>
            </div>
          </div>
        ))}
      </div>
      
      {/* All Projects List */}
      <div className={styles.projectsList}>
        <h3>All Data</h3>
        <div className={styles.projectsGrid}>
          {projectsData.map((proj, index) => {
            // Use garbled text for Launch 2-10 (index 1-9)
            const isGarbled = index >= 1;
            const isOrange = index === 1; // Only Launch 2 is orange (Development)
            const displayName = isGarbled ? 
              garbledText[`launch${index + 1}Name`] || proj.name : 
              proj.name;
            const displayCategory = isGarbled ? 
              garbledText[`launch${index + 1}Category`] || proj.category : 
              proj.category;
            
            return (
              <div key={index} className={`${styles.projectCard} ${isGarbled ? (isOrange ? styles.garbledCardOrange : styles.garbledCard) : ''}`}>
                <div className={styles.cardHeader}>
                  <span className={`${styles.cardName} ${isGarbled ? (isOrange ? styles.garbledTextOrange : styles.garbledText) : ''}`}>
                    {displayName}
                  </span>
                  <span className={`${styles.cardStatus} ${styles[proj.status.toLowerCase()]}`}>
                    {proj.status}
                  </span>
                </div>
                <div className={`${styles.cardCategory} ${isGarbled ? (isOrange ? styles.garbledTextOrange : styles.garbledText) : ''}`}>
                  {displayCategory}
                </div>
              </div>
            );
          })}
          
          {/* Ellipsis to suggest more missions */}
          <div className={styles.moreIndicator}>
            <span className={styles.ellipsis}>...</span>
            <span className={styles.moreText}>Additional missions classified</span>
          </div>
        </div>
      </div>
      
    </div>
  );
}

export default ProjectsModal;
